import axios from "axios";
import Config from "../../../config/index";
import {
  GET_AGEING_REPORT_DOWNLOAD_FAILURE,
  GET_AGEING_REPORT_DOWNLOAD_RANGE_FAILURE,
  GET_AGEING_REPORT_DOWNLOAD_RANGE_REQUEST,
  GET_AGEING_REPORT_DOWNLOAD_RANGE_SUCCESS,
  GET_AGEING_REPORT_DOWNLOAD_REQUEST,
  GET_AGEING_REPORT_DOWNLOAD_SUCCESS,
  GET_AGEING_REPORT_FAILURE,
  GET_AGEING_REPORT_REQUEST,
  GET_AGEING_REPORT_SUCCESS,
  GET_LOCATION_BY_AGEING_FAILURE,
  GET_LOCATION_BY_AGEING_REQUEST,
  GET_LOCATION_BY_AGEING_SUCCESS,
  GET_LOCATION_FAILURE,
  GET_LOCATION_REQUEST,
  GET_LOCATION_SUCCESS,
} from "./ageingReportTypes";

let baseUrl = Config.baseUrl;
let baseUrlReport = Config.baseUrlReport;

const getAgeingReportRequest = () => {
  return {
    type: GET_AGEING_REPORT_REQUEST,
  };
};

const getAgeingReportSuccess = (payload) => {
  return {
    type: GET_AGEING_REPORT_SUCCESS,
    payload: payload,
  };
};

const getAgeingReportFailure = (error) => {
  return {
    type: GET_AGEING_REPORT_FAILURE,
    payload: error,
  };
};

const getAgeingReport = (
  pageNo,
  rowsPerPage,
  search,
  selectedItemType,
  parameterSelected,
  selectedAgeingType,
  concatenatedLocation,
  warehouseCode,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getAgeingReportRequest());

    let url = `${baseUrlReport}/ageing_report?download=0&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${
      search ? search : ""
    }&locationCode=${concatenatedLocation}&warehouseCode=${warehouseCode}&itemTypeId=${selectedItemType}&ageingValue=${parameterSelected}&ageingType=${selectedAgeingType}&startDate=""&endDate=""`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getAgeingReportSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getAgeingReportFailure(err.message));
      });
  };
};
const getAgeingReportDownloadRequest = () => {
  return {
    type: GET_AGEING_REPORT_DOWNLOAD_REQUEST,
  };
};

const getAgeingReportDownloadSuccess = (payload) => {
  return {
    type: GET_AGEING_REPORT_DOWNLOAD_SUCCESS,
    payload: payload,
  };
};

const getAgeingReportDownloadFailure = (error) => {
  return {
    type: GET_AGEING_REPORT_DOWNLOAD_FAILURE,
    payload: error,
  };
};

const getAgeingReportDownload = (
  pageNo,
  rowsPerPage,
  search,
  selectedItemType,
  selectedLocation,
  parameterSelected,
  selectedAgeingType,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getAgeingReportDownloadRequest());
    // let url = `${baseUrl}/reports/ageing_report?itemTypeId=${selectedItemType}&locationId=${selectedLocation}&ageingValue=${parameterSelected}&ageingType=${selectedAgeingType}`;
    let url = `${baseUrlReport}/ageing_report?download=1&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${
      search ? search : ""
    }&itemTypeId=${selectedItemType}&locationId=${selectedLocation}&ageingValue=${parameterSelected}&ageingType=${selectedAgeingType}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getAgeingReportDownloadSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getAgeingReportDownloadFailure(err.message));
      });
  };
};

const getLocationsRequest = () => {
  return {
    type: GET_LOCATION_REQUEST,
  };
};

const getLocationsSuccess = (payload) => {
  return {
    type: GET_LOCATION_SUCCESS,
    payload: payload,
  };
};

const getLocationsFailure = (error) => {
  return {
    type: GET_LOCATION_FAILURE,
    payload: error,
  };
};

const getLocations = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getLocationsRequest());
    let url = `${baseUrl}/location/get_locations`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getLocationsSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getLocationsFailure(err.message));
      });
  };
};
const getLocationsByAgeingRequest = () => {
  return {
    type: GET_LOCATION_BY_AGEING_REQUEST,
  };
};

const getLocationsByAgeingSuccess = (payload) => {
  return {
    type: GET_LOCATION_BY_AGEING_SUCCESS,
    payload: payload,
  };
};

const getLocationsByAgeingFailure = (error) => {
  return {
    type: GET_LOCATION_BY_AGEING_FAILURE,
    payload: error,
  };
};

const getLocationsByAgeing = (selectedAgeingType, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getLocationsByAgeingRequest());
    let url = `${baseUrl}/location/get_loc_by_ageing_type?ageingType=${selectedAgeingType}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getLocationsByAgeingSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getLocationsByAgeingFailure(err.message));
      });
  };
};

const downloadAgeingReportRequest = () => {
  return {
    type: GET_AGEING_REPORT_DOWNLOAD_RANGE_REQUEST,
  };
};

const downloadAgeingReportSuccess = (payload) => {
  return {
    type: GET_AGEING_REPORT_DOWNLOAD_RANGE_SUCCESS,
    payload: payload,
  };
};

const downloadAgeingReportFailure = (error) => {
  return {
    type: GET_AGEING_REPORT_DOWNLOAD_RANGE_FAILURE,
    payload: error,
  };
};

const downloadAgeingReport = (
  startDate,
  endDate,
  pageNo,
  rowsPerPage,
  search,
  selectedItemType,
  // selectedLocation,
  parameterSelected,
  selectedAgeingType,
  concatenatedLocation,
  warehouseCode,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(downloadAgeingReportRequest());
    // let url = `${baseUrl}/reports/ageing_report?download=1&startDate=${endDate}&endDate=${startDate}&page_number=${
    //   pageNo + 1
    // }&rows_per_page=${rowsPerPage}&search=${
    //   search ? search : ""
    // }&itemTypeId=${selectedItemType}&locationId=${selectedLocation}&ageingValue=${parameterSelected}&ageingType=${selectedAgeingType}`
    
    
    let url = `${baseUrlReport}/ageing_report?download=1&startDate=${endDate}&endDate=${startDate}&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${
      search ? search : ""
    }&locationCode=${concatenatedLocation}&warehouseCode=${warehouseCode}&itemTypeId=${selectedItemType}&ageingValue=${parameterSelected}&ageingType=${selectedAgeingType}`

    ;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(downloadAgeingReportSuccess(response.data));
      })
      .catch((err) => {
        dispatch(downloadAgeingReportFailure(err.response));
      });
  };
};

export {
  getAgeingReport,
  getLocations,
  getLocationsByAgeing,
  getAgeingReportDownload,
  downloadAgeingReport,
};
